const DataMenu = {
  // Гарячі страви
  falseDataHotDishes: [
    {
      name: "БУРГЕР КІПІШНИЙ БОДЬКО",
      about:
        "Пишна булочка бріош, фірмовий соус, 2 курячі котлети, 2х сир, салат, помідор, перець гриль, малиновий джем, картопля фрі з соусом",
      volume: "680 г",
      price: "360 грн",
    },
    {
      name: "БУРГЕР ГОЛОДНИЙ ВОЛОДЯ",
      about:
        "пишна булочка бріош, фірмовий соус, котлета із пацятка, подвійний сир, салат, бекон, помідор, тріо цибулевих кілець, джем абрикос-апельсин, картопля фрі з соусом",
      volume: "540 г",
      price: "330 грн",
    },
    {
      name: "БУРГЕР 'ПРАВДИВИЙ РОМКО'",
      about:
        "Пишна булочка бріош, фірмовий соус, котлета із пацятка, реліш із квашених огірків із соусом BBQ, подвійний сир, помідор, цибулька гриль, чорничний джем, картопля фрі з соусом",
      volume: "530 г",
      price: "330 грн",
    },
    {
      name: "ПОЛУМИСОК ВАРЕНИКІВ",
      about: "Вареники з картоплею, сметана, перець, часник",
      volume: "600 г",
      price: "150 грн",
    },
    {
      name: "ПОЛУМИСОК ПЕЛЬМЕНІВ",
      about: "Пельмені яловичина-свинина, 50/50,  перець, соус часниковий",
      volume: "350г",
      price: "175 грн",
    },
    {
      name: "ПАТЕЛЬНЯ МИСЛИВСЬКА",
      about: "Картопля, свинина, печериці, цибуля, кріп",
      volume: "470 г",
      price: "250 грн",
    },
    {
      name: 'ПАТЕЛЬНЯ "НІЖНА КУРОЧКА"',
      about: "Картопля, курка, печериці, твердий сир, вершки",
      volume: "420 г",
      price: "230 грн",
    },
    {
      name: "ПАТЕЛЬНЯ МЕКСИКАНСЬКА З КОВБАСКАМИ",
      about: "Картопля, ковбаски, перець, кукурудза, сир",
      volume: "450 г",
      price: "230 грн",
    },
    {
      name: "ЯЛОВИЧІ СТРІПСИ",
      about: "Яловичина в клярі з соусом на вибір",
      volume: "300 г",
      price: "140 грн",
    },
    {
      name: "ДЕРУНЧИКИ",
      about: "Міні деруни із часниковим соусом або сметаною",
      volume: "300 г",
      price: "140 грн",
    },
    {
      name: "ДЕРУН ПАНСЬКИЙ",
      about: "Картопля, фарш свинний, яйце, сметана, цибуля, томат, сир",
      volume: "700 г",
      price: "240 грн",
    },
    {
      name: "САЛАТ З КУРКОЮ",
      about:
        "Листя салату, перець, куряче філе, фета, насіння соняшника, яблуко, гранатова заправка",
      volume: "300 г",
      price: "180 грн",
    },
    {
      name: "ЦИБУЛЕВІ КІЛЬЦЯ",
      about: "Цибулька у клярі, соус",
      volume: "250 г",
      price: "120 грн",
    },
    {
      name: "КАРТОПЛЯ ФРІ",
      about: "Файні ломтики картоплі із соусом на вибір",
      volume: "300 г",
      price: "80 грн",
    },
    {
      name: "КАРТОПЛЯ ФРІ З СИРОМ",
      about: "Файні ломтики картоплі з сиром і соусом на вибір",
      volume: "350 г",
      price: "100 грн",
    },
    {
      name: "НАГЕТСИ/СТРІПСИ",
      about: "Шматки курячого філе у клярі із сухарів, соус",
      volume: "300 г",
      price: "140 грн",
    },
    {
      name: "КАЛЬМАР ТЕМПУРА",
      about: "Кільця кальмару в хрусткій паніровці із соусом на вибір",
      volume: "300 г",
      price: "210 грн",
    },
  ],
  // Дошки
  falseDataSnacks: [
    {
      name: "МЕКСИКАНСЬКА ДОШКА",
      about: "Гуакамоле, чіпси начос, ковбаски з гострим соусом",
      volume: "700 г",
      price: "600 грн",
    },
    {
      name: "МЯСНА ДОШКА",
      about:
        "Махан, сировялена ковбаса, шовдир, курячі джерки,ковбаски чорізо, Закарпатські вогняні ковбаски",
      volume: "300 г",
      price: "500 грн",
    },
    {
      name: "КРАНЧ ДОШКА",
      about: "Арахіс солений, кранч в асортименті, кукурудза, грінки",
      volume: "300 г",
      price: "200 грн",
    },
    {
      name: "ПИВНА ДОШКА",
      about: "Цибулеві кільця, джерки, картопля фрі, копчений сулугуні, арахіс",
      volume: "500 г",
      price: "300 грн",
    },
    {
      name: "ДОШКА З САЛОМ",
      about: "Сало, чорний хліб, квашений огірок, цибуля зелена, хрін",
      volume: "530 г",
      price: "350 грн",
    },
    {
      name: "ДОШКА ІЗ СИРНИМИ ПРИКОЛАМИ",
      about:
        "сирні кульки, бочонки філадельфія з базиліком і томатом, кульки моцарели, картопляні шарики, соус",
      volume: "450 г",
      price: "400 грн",
    },
    {
      name: "ВЕЛИКА ТАЦЯ",
      about:
        "Фрі, ковбаски гриль, цибулеві кільця, грінки, сулугуні, чіпси з лавашу, соломка з свинини, курячі чіпси, джерки, чері, 3 різні соуси",
      volume: "1000 г",
      price: "800 грн",
    },
  ],
  //Соуси власного виробництва
  falseDataSauces: [
    {
      name: "Барбекю з чорносливом",
      volume: "50 г",
      price: "20 грн",
    },
    {
      name: "Часниковий з кропом",
      volume: "50 г",
      price: "20 грн",
    },
    {
      name: "солодкий чилі",
      volume: "50 г",
      price: "20 грн",
    },
    {
      name: "червоний гострий",
      volume: "50 г",
      price: "20 грн",
    },
    {
      name: "томатний негострий",
      volume: "50 г",
      price: "20 грн",
    },
    {
      name: "сирний",
      volume: "50 г",
      price: "20 грн",
    },
  ],
  // Алькогольні напої
  falseDataAlcohol: [
    {
      name: "КОЗАЦЬКА РАДА",
      about: "ГОРІЛКА",
      volume: "0.5 л",
      price: "300 грн",
    },
    {
      name: "ХЛІБНИЙ ДАР",
      about: "ГОРІЛКА",
      volume: "0.5 л",
      price: "270 грн",
    },
    {
      name: "ГЕТЬМАН",
      about: "ГОРІЛКА",
      volume: "0.5 л",
      price: "300 грн",
    },
    {
      name: "АЗНАУРІ 3*",
      about: "КОНЬЯК",
      volume: "0.5 л",
      price: "500 грн",
    },
    {
      name: "АЗНАУРІ 4*",
      about: "КОНЬЯК",
      volume: "0.5 л",
      price: "550 грн",
    },
    {
      name: "АЗНАУРІ 5*",
      about: "КОНЬЯК",
      volume: "0.5 л",
      price: "600 грн",
    },
  ],
  // Сети настоянок
  falseDataShota: [
    {
      name: "БОГДАНІВ СЛОЇК",
      about: "СЛОЇК НАЛИВОК",
      volume: "2 Л",
      price: "800 грн",
    },
    {
      name: "БОГДАНІВ СЛОЇК",
      about: "СЛОЇК НАЛИВОК",
      volume: "3 Л",
      price: "1200 грн",
    },
    {
      name: "БОГДАНІВ СЛОЇК",
      about: "СЛОЇК НАЛИВОК",
      volume: "4.5 Л",
      price: "1800 грн",
    },
    {
      name: "СЕТ НАЛИВОК 6 ЧАРОК",
      about: "ВИШНЕВА,ЖУРАВЛИНА, ОЖИНА, ПОЛУНИЦЯ, АБРИКОС, СУНИЦЯ, СЛИВА",
      volume: "300 мл",
      price: "180 грн",
    },
    {
      name: "СЕТ НАЛИВОК 12 ЧАРОК",
      about: "ВИШНЕВА,ЖУРАВЛИНА, ОЖИНА, ПОЛУНИЦЯ, АБРИКОС, СУНИЦЯ , СЛИВА",
      volume: "600 мл",
      price: "350 грн",
    },
    {
      name: "СЕТ НАСТОЯНОК 6 ЧАРОК",
      about: "МЕДОВА, ЖУРАВЛИНА",
      volume: "300 мл",
      price: "240 грн",
    },
    {
      name: "СЕТ НАСТОЯНОК 12 ЧАРОК",
      about: "ЖУРАВЛИНА, МЕДОВА",
      volume: "600 мл",
      price: "480 грн",
    },
    {
      name: "СЕТ ШОТІВ 5 ШТ ЛЕГКИЙ РІВЕНЬ",
      about:
        "ДЯДЬКО ІВАН, ПОВСТАНЕЦЬ, СЛАВА УКРАЇНІ, СРІБНА КУЛЯ, ЗЕЛЕНИЙ МЕКСИКАНЕЦЬ",
      volume: "300 мл",
      price: "600 грн",
    },
    {
      name: "СЕТ ШОТІВ 10 ШТ СЕРЕДНІЙ РІВЕНЬ",
      about: "УСІ ВИДИ ЗАЛПОВИХ КОКТЕЙЛІВ",
      volume: "600 мл",
      price: "1200 грн",
    },
    {
      name: "СЕТ ШОТІВ 20 ШТ ВАЖКИЙ РІВЕНЬ",
      about: "УСІ ВИДИ ЗАЛПОВИХ КОКТЕЙЛІВ 2Х",
      volume: "1200 мл",
      price: "2400 грн",
    },
    {
      name: "БРОНЕПОЇЗД 6 ЧАРОК",
      about:
        "МАРТІНІ, ГОРІЛКА, АБСЕНТ, АПЕЛЬСИНОВИЙ СІК, СПРАЙТ, ТОМАТНИЙ СІК.",
      volume: "300 мл",
      price: "300 грн",
    },
  ],
  // Пиво -
  falseDataBeer: [
    {
      name: "",
      about: "",
      volume: " л",
      price: " грн",
    },
  ],
  // Коктейлі
  falseDataCoctel: [
    {
      name: "CHERRY GIN SOUR",
      about: "ТОНІК, ДЖИН, ЛАЙМ, ВИШНЕВИЙ СІК",
      volume: "200 мл",
      price: "200 грн",
    },
    {
      name: "MARTINI TONIC",
      about: "МАРТІНІ, ТОНІК, ЛАЙМ",
      volume: "220 мл",
      price: "170 грн",
    },
    {
      name: "ДОТИК",
      about: "БІЛИЙ РОМ, ШАМПАНСЬКЕ, СИРОП ЯГІДНИЙ, МЯТА, МЕД.",
      volume: "280 мл",
      price: "190 грн",
    },
    {
      name: "ФРАНЦУЗ",
      about:
        "ДЖИН, БЛЮ КУРАСАО, ЦУКРОВИЙ СИРОП, ЛАЙМОВИЙ СІК, 7UP, ЦУКОР, ІМБИР.",
      volume: "200 мл",
      price: "190 грн",
    },
    {
      name: "LONDON TEA",
      about:
        "ЧОРНИЙ ЧАЙ, ДЖИН ,ГОРІЛКА, ЗОЛОТИЙ POM, BICKІ, ТЕКІЛА СРІБНА, ЛИМОН.",
      volume: "500 мл",
      price: "230 грн",
    },
    {
      name: "ZOMBI FATALITY",
      about: "ШАМПАНСЬКЕ. ВИШНЕВИЙ СІК. ТЕКІЛА, АБСЕНТ, МАРТІНІ, ЛИМОН, ЛАЙМ.",
      volume: "500 мл",
      price: "250 грн",
    },
    {
      name: "MOXITO",
      about: "СПРАЙТ, М'ЯТА, ЛИМОН, ЛАЙМ, ТРОСТИНКОВИЙ ЦУКОР, ГОРІЛКА.",
      volume: "500 мл",
      price: "150 грн",
    },
    {
      name: "АПЕРОЛЬ ШПРІЦ",
      about: "ШАМПАНСЬКЕ, АПЕРОЛЬ, СПРАЙТ, АПЕЛЬСИН",
      volume: "300 мл",
      price: "250 грн",
    },
    {
      name: "BLOODY DRACULA",
      about: "ВИШНЕВИЙ СІК, ВІСКІ, БЕХЕРОВКА, ЛИМОННИЙ СІК.",
      volume: "250 мл",
      price: "220 грн",
    },
    {
      name: "АФЕРА",
      about: "ДИННИЙ ЛІКЕР,ЛАЙМОВИЙ CIK, ТОНІК, ЛАЙМ.",
      volume: "250 мл",
      price: "200 грн",
    },
    {
      name: "АЛІГАТОР",
      about:
        "СПРАЙТ,АПЕЛЬСИНОВИЙ СІК, ГОРІЛКА, ЛІКЕР ДИНЯ, АПЕЛЬСИНОВИЙ ЛІКЕР, ЛИМОННИЙ СІК.",
      volume: "200 мл",
      price: "190 грн",
    },
    {
      name: "ЗЕЛЕНА ФЕЯ",
      about:
        "НОН-СТОП, БІЛИЙ РОМ, ГОРІЛКА, ТЕКІЛА, АБСЕНТ, ЛІКЕР ЗЕЛЕНА ДИНЯ, ЛИМОННИЙ СІК, БЛЮ КУРАСАО",
      volume: "300 мл",
      price: "230 грн",
    },
    {
      name: "СМОРОДИНОВИЙ ВІСКІ САУЕР",
      about: "ВІСКІ, СМОРОДИНОВИЙ БАЛЬЗАМ, ЛИМОННИЙ СІК",
      volume: "150 мл",
      price: "220 грн",
    },
    {
      name: "КВІТКОВИЙ КЛУБ",
      about: "ДЖИН, ЯКІДНИЙ СИРОП, ЛИМОННИЙ СІК, ЛЕГКА ПІНКА",
      volume: "150 мл",
      price: "180 грн",
    },
    {
      name: "ТЕКІЛА БУМ",
      about: "ТЕКІЛА, 7-UP",
      volume: "150 мл",
      price: "150 грн",
    },
    {
      name: "НЕГРОНІ",
      about: "ДЖИН, ЧЕРВОНЕ МАРТІНІ, АПЕЛЬСИНОВИЙ БІТТЕР, ЦЕДРА АПЕЛЬСИНУ",
      volume: "200 мл",
      price: "230 грн",
    },
    {
      name: "ДЖИН ТОНІК",
      about: "ДЖИН, ТОНІК, ЛИМОН",
      volume: "200 мл",
      price: "170 грн",
    },
  ],
  // Залпові напої
  falseDataFireDrink: [
    {
      name: "ХІРОСІМА",
      about: "(ПАЛАЄ) САМБУКА, КРЕМОВИЙ ЛІКЕР, АБСЕНТ, ГРАНАТОВИЙ СИРОП",
      volume: "60 мл",
      price: "160 грн",
    },
    {
      name: "В-52",
      about: "(ПАЛАЄ) КАВОВИЙ ЛІКЕР КРЕМОВИЙ ЛІКЕР ТРИПЛ-СЕК",
      volume: "60 мл",
      price: "160 грн",
    },
    {
      name: "ЗЕЛЕНИЙ МЕКСИКАНЕЦЬ",
      about: "ЛІКЕР ЗЕЛЕНИЙ БАНАН ЛИМОННИЙ",
      volume: "60 мл",
      price: "140 грн",
    },
    {
      name: "ВІЛЬНА КУБА",
      about: "ЛІКЕР ЗЕЛЕНИЙ БАНАН, КОКОСОВИЙ ЛІКЕР, МАРТІНІ РОССО, ТЕМНИЙ РОМ.",
      volume: "60 мл",
      price: "160 грн",
    },
    {
      name: "СРІБНА КУЛЯ",
      about: "КАВОВИЙ ЛІКЕР,ТЕКІЛА,ЛИМОН.",
      volume: "60 мл",
      price: "120 грн",
    },
    {
      name: "ТАРАКАН",
      about: "(ПАЛАЄ) Kавовий ЛІКЕР. CAMБУKA, АБСЕНТ",
      volume: "60 мл",
      price: "180 грн",
    },
    {
      name: "ДЯДЬКО ІВАН",
      about: "ГРЕНАДІН,ЛИМОННИЙ СІК,ГОРІЛКА.",
      volume: "60 мл",
      price: "100 грн",
    },
    {
      name: "ГОРИТЬ МОСКВА",
      about: "(ПАЛАЄ) БУРБОН, КРЕМОВИЙ ЛІКЕР, ЛІКЕР АМАРЕТТО.",
      volume: "60 мл",
      price: "180 грн",
    },
    {
      name: "СЛАВА УКРАЇНІ",
      about: "ЛИМОННИЙ СИРОП,БЛЮ КУРАСАО,ГОРІЛКА",
      volume: "60 мл",
      price: "100 грн",
    },
    {
      name: "ПОВСТАНЕЦЬ",
      about: "JAGERMEISTER, MAPТІНІ POCCO",
      volume: "60 мл",
      price: "160 грн",
    },
  ],
  // Вино
  falseDataVine: [
    {
      name: "CHIZAY MERLO",
      about: "СУХЕ",
      volume: "0.7 л",
      price: "320 грн",
    },
    {
      name: "CHIZAY PINO BLAN",
      about: "НАПІВСОЛОДКЕ",
      volume: "0.7 л",
      price: "320 грн",
    },
    {
      name: "CHIZAY KABERNE",
      about: "НАПІВСОЛОДКЕ",
      volume: "0.7 л",
      price: "320 грн",
    },
    {
      name: "CHIZAY TRAMINER DESERT",
      about: "СУХЕ",
      volume: "0.7 л",
      price: "320 грн",
    },
    {
      name: "CHIZAY KABERNE",
      about: "СУХЕ",
      volume: "0.7 л",
      price: "320 грн",
    },
    {
      name: "ASTI",
      about: "СОЛОДКЕ ІГРИСТЕ",
      volume: "0.7 л",
      price: "320 грн",
    },
  ],
  // Безалкогольні напої
  falseDataFreeDrink: [
    {
      name: "СІК САНДОРА В АСОРТИМЕНТІ",
      about: "",
      volume: "1 л",
      price: "170 грн",
    },
    {
      name: "ПЕПСІ",
      about: "",
      volume: "1 л",
      price: "60 грн",
    },
    {
      name: "ПЕПСІ",
      about: "",
      volume: "500 мл",
      price: "45 грн",
    },
    {
      name: "комбуча",
      about: "",
      volume: "0.35л",
      price: "80 грн",
    },
    {
      name: "комбуча з каннабіолом",
      about: "",
      volume: "0.35 л",
      price: "100 грн",
    },
    {
      name: "EVERVESS TONIC",
      about: "",
      volume: "250 мл",
      price: "35 грн",
    },
    {
      name: "7-UP",
      about: "",
      volume: "1 л",
      price: "60 грн",
    },
    {
      name: "Енергетик",
      about: "",
      volume: "250 мл",
      price: "60 грн",
    },
    {
      name: "ПІДПІЛЬНА КАВА",
      about: "",
      volume: "200 мл",
      price: "50 грн",
    },
    {
      name: "ЧАЙ",
      about: "",
      volume: "200 мл",
      price: "40 грн",
    },
  ],
  // Пивна дошка
  falseDataBeerBoard: [
    {
      name: "МАЦИК",
      volume: "50",
      price: "80",
    },
    {
      name: "ХРУСТКИЙ СИР",
      volume: "50",
      price: "85",
    },
    {
      name: "КУРЯЧІ ДЖЕРКИ",
      volume: "100",
      price: "80",
    },
    {
      name: "СИРОВЯЛЕНА КОВБАСА",
      volume: "50",
      price: "80",
    },
    {
      name: "ШОВДИР",
      volume: "50",
      price: "80",
    },
    {
      name: "СВИННІ ДЖЕРКИ З ТОМАТАМИ",
      volume: "50",
      price: "90",
    },
    {
      name: "СМУГИ КАЛЬМАРУ",
      volume: "50",
      price: "75",
    },
    {
      name: "ЯНТАРНА РИБКА",
      volume: "50",
      price: "70",
    },
    {
      name: "СМУГАСТИК",
      volume: "50",
      price: "70",
    },
    {
      name: "СУЛУГУНІ КОПЧЕНИЙ",
      volume: "100",
      price: "70",
    },
    {
      name: "APAXIC КРАНЧ",
      volume: "100",
      price: "38",
    },
    {
      name: "АРАХІС СОЛЕНИЙ",
      volume: "100",
      price: "35",
    },
    {
      name: "КУКУРУДЗА ЖАРЕНА",
      volume: "100",
      price: "60",
    },
    {
      name: "ГРІНКИ",
      volume: "100",
      price: "40",
    },
    {
      name: "ЧІПСИ З ЛАВАШУ",
      volume: "100",
      price: "65",
    },
    {
      name: "ПАЛИЧКИ СВИННІ ВИШНЕВІ",
      volume: "50",
      price: "80",
    },
    {
      name: "ДЖЕРКИ КОНИНА",
      volume: "50",
      price: "80",
    },
    {
      name: "ПАЛИЧКИ СУДЖУК",
      volume: "50",
      price: "60",
    },
    {
      name: "КУРЯЧІ ЧІПСИ",
      volume: "50",
      price: "90",
    },
    {
      name: "КАЧИНІ СЛАЙСИ",
      volume: "50",
      price: "70",
    },
    {
      name: "ФІСТАШКИ",
      volume: "50",
      price: "60",
    },
    {
      name: "ТАРАНЬКА",
      volume: "1 шт.",
      price: "50",
      isCustomVolume: true,
    },
  ],
  // Акційна пропозиція
  falseDataPromotion: [
    {
      data: "",
      promotion: "",
    },
  ],
};

export default DataMenu;
